
export const COLOR_CLASSES = {
  "Custom-Category-Blue": "bg-Custom-Category-Blue",
  "Custom-Category-Red": "bg-Custom-Category-Red",
  "Custom-Category-Green": "bg-Custom-Category-Green",
  "Custom-Category-Purple": "bg-Custom-Category-Purple",
  "Custom-Category-Orange": "bg-Custom-Category-Orange",
  "Custom-Category-Pink": "bg-Custom-Category-Pink",
  "Custom-Category-Yellow": "bg-Custom-Category-Yellow",
  "Custom-Category-Brown": "bg-Custom-Category-Brown",
};
